// 좌측 사이드바 — poc-portal Sidebar 이식판 (react-router → lib/navigation 훅으로 교체)
import React, { useState, useEffect } from 'react';
import { usePathname, navigate } from '../../lib/navigation';
import styles from './Sidebar.module.css';

interface NavItem {
  id: string;
  label: string;
  path?: string | null;
  badge?: string;
  icon: JSX.Element;
}

const navGroups: { divider?: boolean; items: NavItem[] }[] = [
  {
    items: [
      {
        id: 'home', label: '홈', path: '/',
        icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>,
      },
      {
        id: 'mail', label: '메일', path: '/mail',
        icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/><path d="M22 6l-10 7L2 6"/></svg>,
      },
      {
        id: 'chat', label: '메신저', badge: '3', path: '/messenger',
        icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
      },
      {
        id: 'board', label: '게시판', path: '/board',
        icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 6h16M4 10h16M4 14h10"/></svg>,
      },
      {
        id: 'video', label: '화상회의', path: '/videoconf',
        icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M15 10l4.553-2.069A1 1 0 0 1 21 8.82v6.36a1 1 0 0 1-1.447.89L15 14M3 8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>,
      },
    ],
  },
  {
    divider: true,
    items: [
      {
        id: 'oneffice', label: 'ONEFFICE', path: '/oneffice',
        icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
      },
      {
        id: 'onechamber', label: 'ONECHAMBER', path: '/onechamber',
        icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>,
      },
    ],
  },
  {
    divider: true,
    items: [
      {
        id: 'finance', label: '회계관리', path: '/finance',
        icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18"/><path d="M7 15l4-4 3 3 5-6"/></svg>,
      },
      {
        id: 'basicinfo', label: '기초정보관리', path: '/basicinfo',
        icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><ellipse cx="12" cy="5" rx="8" ry="3"/><path d="M4 5v14c0 1.66 3.58 3 8 3s8-1.34 8-3V5"/><path d="M4 12c0 1.66 3.58 3 8 3s8-1.34 8-3"/></svg>,
      },
    ],
  },
  {
    divider: true,
    items: [
      {
        id: 'erp-tax', label: 'ERP 세무', path: null,
        icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M9 7H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2M9 12h6M9 16h4"/></svg>,
      },
      {
        id: 'erp-account', label: 'ERP 회계', path: '/erp',
        icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M8 6h8M16 14v4M16 10h.01M12 10h.01M8 10h.01M12 14h.01M8 14h.01M12 18h.01M8 18h.01"/></svg>,
      },
    ],
  },
];

const bottomItems: NavItem[] = [
  {
    id: 'ai-usage', label: 'AI 사용량', path: '/admin/ai-usage',
    icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21h18"/><rect x="5" y="10" width="3.5" height="8" rx="1"/><rect x="10.25" y="5" width="3.5" height="13" rx="1"/><rect x="15.5" y="13.5" width="3.5" height="4.5" rx="1"/></svg>,
  },
  {
    id: 'settings', label: '설정', path: '/settings',
    icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
  },
  {
    id: 'help', label: '도움말', path: null,
    icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3M12 17h.01"/></svg>,
  },
];

function getActiveId(pathname: string): string {
  if (pathname.startsWith('/mail')) return 'mail';
  if (pathname.startsWith('/oneffice')) return 'oneffice';
  if (pathname.startsWith('/messenger')) return 'chat';
  if (pathname.startsWith('/board')) return 'board';
  if (pathname.startsWith('/onechamber')) return 'onechamber';
  if (pathname.startsWith('/finance')) return 'finance';
  if (pathname.startsWith('/videoconf')) return 'video';
  if (pathname.startsWith('/erp')) return 'erp-account';
  if (pathname.startsWith('/basicinfo')) return 'basicinfo';
  if (pathname.startsWith('/admin/ai-usage')) return 'ai-usage';
  if (pathname.startsWith('/settings')) return 'settings';
  if (pathname === '/') return 'home';
  return '';
}

export default function Sidebar() {
  const pathname = usePathname();
  const activeId = getActiveId(pathname);

  /* ── 사이드바 고정 상태
   *  기본값 collapsed (false), 핀 버튼 단독 제어
   *  마우스 오버 확장 없음
   */
  const [isPinned, setIsPinned] = useState<boolean>(() => {
    const stored = localStorage.getItem('sidebarPinned');
    return stored === null ? false : stored === 'true'; // 기본값: collapsed
  });

  /* body.sidebarPinned → Layout + Home CSS 연동 */
  useEffect(() => {
    document.body.classList.toggle('sidebarPinned', isPinned);
  }, [isPinned]);

  const togglePin = () => {
    const next = !isPinned;
    setIsPinned(next);
    localStorage.setItem('sidebarPinned', String(next));
  };

  const handleClick = (item: NavItem) => {
    if (item.path) navigate(item.path);
  };

  /* expanded = isPinned 만으로 결정 (호버 없음) */
  const isExpanded = isPinned;

  return (
    <aside className={`${styles.sidebar} ${isExpanded ? styles.expanded : ''}`}>

      {/* 새 AI 대화 버튼 */}
      <button className={styles.newChatBtn} onClick={() => {
        const chatId = `ai-${Date.now()}`;
        window.dispatchEvent(new CustomEvent('navNewAiChat', { detail: { chatId } }));
        navigate('/');
      }}>
        <span className={styles.newChatBtnIcon}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="rgba(255,255,255,.85)">
            <path d="M12 2 L13.5 10.5 L22 12 L13.5 13.5 L12 22 L10.5 13.5 L2 12 L10.5 10.5 Z"/>
          </svg>
        </span>
        <span className={styles.newChatBtnText}>새 AI 대화</span>
      </button>

      {/* 네비게이션 그룹 */}
      {navGroups.map((group, gi) => (
        <div key={gi}>
          {group.divider && <div className={styles.navDivider} />}
          {group.items.map(item => (
            <div
              key={item.id}
              className={`${styles.navItem} ${activeId === item.id ? styles.active : ''}`}
              onClick={() => handleClick(item)}
            >
              <div className={styles.iconWrap}>
                {item.icon}
                {item.badge && <span className={styles.badgeDot}>{item.badge}</span>}
              </div>
              <span className={styles.navLabel}>{item.label}</span>
              {item.badge && <span className={styles.badge}>{item.badge}</span>}
            </div>
          ))}
        </div>
      ))}

      <div className={styles.spacer} />

      {/* ── 사이드바 고정 핀 버튼 — 설계서 v4.0: 유일한 토글 수단 ── */}
      <div
        className={`${styles.navItem} ${styles.pinBtn} ${isPinned ? styles.pinned : ''}`}
        onClick={togglePin}
        title={isPinned ? '사이드바 접기' : '사이드바 고정'}
        role="button"
        aria-pressed={isPinned}
      >
        <div className={styles.iconWrap}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 4l6 6-3 1-4 4-1 5-3-3-5 3 3-5-3-3 5-1 4-4z"/>
          </svg>
        </div>
        <span className={styles.navLabel}>
          {isPinned ? '사이드바 접기' : '고정하기'}
        </span>
      </div>

      <div className={styles.navDivider} />

      {/* 설정/도움말 */}
      {bottomItems.map(item => (
        <div
          key={item.id}
          className={`${styles.navItem} ${activeId === item.id ? styles.active : ''}`}
          onClick={() => handleClick(item)}
        >
          <div className={styles.iconWrap}>{item.icon}</div>
          <span className={styles.navLabel}>{item.label}</span>
        </div>
      ))}
    </aside>
  );
}
